"use client";
import { useState } from "react";
import CommunityHeads from "~/components/v3/community-components/CommunityHeads";
import { If } from "~/components/v3/Conditional";
import Modal from "~/components/v3/themed/Modal";
import UserImage from "~/components/v3/users-components/UserImage";

export const WhosAttending = ({
    attendees,
}: {
    attendees:
        | {
              user: {
                  id: string;
                  name: string | null;
                  image: string | null;
                  slug: string | null;
              };
          }[]
        | null;
}) => {
    const [isMoreVisible, setIsMoreVisible] = useState(false);
    if (!attendees) return null;
    return (
        <>
            <div
                className="flex max-w-max flex-col gap-2 hover:cursor-pointer"
                onClick={() => setIsMoreVisible(true)}
            >
                <span className="text-sm text-v3-N-300">
                    {attendees.length} will attend
                </span>
                <CommunityHeads
                    users={attendees.map((attendee) => attendee.user)}
                    spaceIcons={false}
                    showMax={5}
                    iconSize={30}
                    revealPII={false}
                    profileLink={false}
                />
                {attendees.length > 2 && (
                    <span>
                        {attendees[0]!.user.name}, {attendees[1]!.user.name} and{" "}
                        {attendees.length - 2} more
                    </span>
                )}
            </div>
            <Modal
                open={isMoreVisible}
                onOpenChange={() => setIsMoreVisible(false)}
                title="Who's attending?"
                description="This is a list of all the people who have RSVPed to this event."
            >
                <div className="flex h-full max-h-[300px] flex-col gap-2 overflow-y-auto">
                    {attendees.map((attendee) => (
                        <div
                            key={attendee.user.id}
                            className="flex items-center gap-2"
                        >
                            <UserImage user={attendee.user} iconSize={30} />
                            <div className="flex flex-col">
                                <p className="text-sm">{attendee.user.name}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </Modal>
        </>
    );
};

export const WhosHosting = ({
    hosts,
}: {
    hosts: {
        id: string;
        user: {
            name: string | null;
            image: string | null;
            slug: string | null;
        };
    }[];
}) => {
    return (
        <>
            {hosts.length > 0 && (
                <div className="flex flex-wrap items-center gap-1">
                    <CommunityHeads
                        users={hosts.map((h) => h.user)}
                        spaceIcons={false}
                        showMax={5}
                        iconSize={30}
                        revealPII={false}
                        profileLink={false}
                    />
                    <span className="ml-1" />
                    Hosted by{" "}
                    {hosts.map((host, idx) => (
                        <span key={host.id} className="w-max">
                            {host.user.name}
                            {idx !== hosts.length - 1 && ", "}
                        </span>
                    ))}
                </div>
            )}
        </>
    );
};
